import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));
export const VendorPreEventForm = Loadable(
  lazy(() => import('../pages/dashboard/VendorPreConventionForm'))
);
export const VendorPostEventForm = Loadable(
  lazy(() => import('../pages/dashboard/VendorPostConventionForm'))
);

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(lazy(() => import('../pages/dashboard/GeneralAppPage')));

export const MainDashboard = Loadable(lazy(() => import('../pages/dashboard/MainDashboard')));

export const MEIDTDashboard = Loadable(lazy(() => import('../pages/dashboard/MEIDTDashboard')));

export const MEITDTalentAnalyticsDashboard = Loadable(lazy(() => import('../pages/dashboard/MEITDTalentAnalyticsDashboard')));
export const TalentIntelligencePage = Loadable(lazy(() => import('../pages/dashboard/TalentIntelligencePage')));
export const TalentSectorPage = Loadable(lazy(() => import('../pages/dashboard/TalentSectorPage')));
export const TalentForecastPage = Loadable(lazy(() => import('../pages/dashboard/TalentForecastPage')));
export const PCDSImpactPage = Loadable(lazy(() => import('../pages/dashboard/PCDSImpactPage')));
export const TalentIntelligenceForecastPage = Loadable(lazy(() => import('../pages/dashboard/TalentIntelligenceForecastPage')));
export const PredictionPage = Loadable(lazy(() => import('../pages/dashboard/PredictionPage')));

export const MEITDSkillsGapDashboard = Loadable(lazy(() => import('../pages/dashboard/MEITDSkillsGapDashboard')));
export const AILabourPrediction = Loadable(lazy(() => import('../pages/dashboard/AILabourPrediction')));
export const MEITDAIAssistantPage = Loadable(lazy(() => import('../pages/dashboard/MEITDAIAssistantPage')));

export const EventDetail = Loadable(lazy(() => import('../pages/dashboard/EventDetail')));

export const PDFDetail = Loadable(lazy(() => import('../pages/dashboard/PDFDetail')));

export const EventListPage = Loadable(lazy(() => import('../pages/dashboard/EventListPage')));

export const EventFormPage = Loadable(lazy(() => import('../pages/dashboard/EventForm')));

export const LegacyImpactDashboardPage = Loadable(
  lazy(() => import('../pages/dashboard/LegacyImpactDashboardPage'))
);
export const KFADashboardPage = Loadable(lazy(() => import('../pages/dashboard/KFADashbaordPage')));
export const UNSDGDashboardPage = Loadable(
  lazy(() => import('../pages/dashboard/UNSDGDashboardPage'))
);

// DASHBOARD: REPORT
export const KFAReportPage = Loadable(lazy(() => import('../pages/dashboard/KFAReportPage')));
export const CaseStudiesReportPage = Loadable(
  lazy(() => import('../pages/dashboard/CaseStudiesReportPage'))
);
export const UNSDGReportPage = Loadable(lazy(() => import('../pages/dashboard/UNSDGReportPage')));

//

export const OverallEventsPage = Loadable(
  lazy(() => import('../pages/dashboard/OverallEventsPage'))
);
export const LegacyEventsPage = Loadable(lazy(() => import('../pages/dashboard/LegacyEventsPage')));
export const CaseStudiesPage = Loadable(lazy(() => import('../pages/dashboard/CaseStudiesPage')));
export const EventInProcessList = Loadable(
  lazy(() => import('../pages/dashboard/application/EventInProcessList'))
);

export const EventOrganizer = Loadable(lazy(() => import('../pages/dashboard/EventOrganizer')));

// DASHBOARD: USER
export const UserProfilePage = Loadable(lazy(() => import('../pages/dashboard/UserProfilePage')));
export const UserCardsPage = Loadable(lazy(() => import('../pages/dashboard/UserCardsPage')));
export const UserListPage = Loadable(lazy(() => import('../pages/dashboard/UserListPage')));
export const UserAccountPage = Loadable(lazy(() => import('../pages/dashboard/UserAccountPage')));
export const UserCreatePage = Loadable(lazy(() => import('../pages/dashboard/UserCreatePage')));
export const UserEditPage = Loadable(lazy(() => import('../pages/dashboard/UserEditPage')));

// DASHBOARD: APP
export const ChatPage = Loadable(lazy(() => import('../pages/dashboard/ChatPage')));
export const MailPage = Loadable(lazy(() => import('../pages/dashboard/MailPage')));
export const CalendarPage = Loadable(lazy(() => import('../pages/dashboard/CalendarPage')));

// DASHBOARD: BID BRIEF
export const BidBriefListPage = Loadable(
  lazy(() => import('../pages/dashboard/bidBrief/BidBriefListPage'))
);

// TEST RENDER PAGE BY ROLE
export const PermissionDeniedPage = Loadable(
  lazy(() => import('../pages/dashboard/PermissionDeniedPage'))
);

// BLANK PAGE
export const BlankPage = Loadable(lazy(() => import('../pages/dashboard/BlankPage')));

// MAIN
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const FaqsPage = Loadable(lazy(() => import('../pages/FaqsPage')));
export const AboutPage = Loadable(lazy(() => import('../pages/AboutPage')));
export const Contact = Loadable(lazy(() => import('../pages/ContactPage')));
export const PaymentPage = Loadable(lazy(() => import('../pages/PaymentPage')));
export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')));
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));

// Conference Management
export const ConferenceEventManagementIndexPage = Loadable(
  lazy(() => import('../pages/dashboard/event-management/ConferenceEventManagementIndexPage'))
);
export const ConferenceEventManagementForm = Loadable(
  lazy(() => import('../pages/dashboard/event-management/ConferenceEventManagementForm'))
);
export const SurveyManagementIndexPage = Loadable(
  lazy(() => import('../pages/dashboard/survey-management/SurveyMamagementIndexPage'))
);
export const SurveyForm = Loadable(
  lazy(() => import('../pages/dashboard/survey-management/SurveyForm'))
);
export const JournalManagementIndexPage = Loadable(
  lazy(() => import('../pages/dashboard/journal-management/JournalManagementIndexPage'))
);
export const SettingManagement = Loadable(
  lazy(() => import('../pages/dashboard/settings/SettingManagement'))
);
export const EmailTemplatelisting = Loadable(
  lazy(() => import('../pages/dashboard/settings/emailTemplate/emailTemplateListing'))
);
export const EventLegacyPage = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/EventLegacyPage'))
);
export const ConventionandExhibitionApplicationForm = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/ConventionandExhibitionApplicationForm'))
);
export const PreForm = Loadable(lazy(() => import('../pages/dashboard/event-legacy/PreForm')));
export const QuestionnairePage1 = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/QuestionnaireSection/QuestionnairePage1'))
);
export const QuestionnairePage2 = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/QuestionnaireSection/QuestionnairePage2'))
);
export const QuestionnairePage3 = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/QuestionnaireSection/QuestionnairePage3'))
);
export const QuestionnairePage4 = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/QuestionnaireSection/QuestionnairePage4'))
);
export const QuestionnairePage5 = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/QuestionnaireSection/QuestionnairePage5'))
);
export const QuestionnairePage6 = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/QuestionnaireSection/QuestionnairePage6'))
);
export const EventRegisterForm = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/EventRegisterForm'))
);
export const LegacyReportForm = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/LegacyReportForm'))
);
export const UploadData = Loadable(
  lazy(() => import('../pages/dashboard/event-legacy/UploadData'))
);

export const OrganizerDashboard = Loadable(
  lazy(() => import('../pages/dashboard/organizer/OrganizerDashboard'))
);

export const OrganizerKFADashboardPage = Loadable(
  lazy(() => import('../pages/dashboard/organizer/OrganizerKFADashboardPage'))
);

export const OrganizerUNSDGDashboardPage = Loadable(
  lazy(() => import('../pages/dashboard/organizer/OrganizerUNSDGDashboardPage'))
);
export const OrganizerCaseStudiesPage = Loadable(
  lazy(() => import('../pages/dashboard/organizer/OrganizerCaseStudiesPage'))
);

export const OrganizerLegacyEventsPage = Loadable(
  lazy(() => import('../pages/dashboard/organizer/OrganizerLegacyEventsPage'))
);





export const EventApplicationPage = Loadable(
  lazy(() => import('../pages/dashboard/event-application-forms/EventApplicationPage'))
);
// INVENTORY

// LEGACY IMPACT
export const LegacyImpactPage = Loadable(lazy(() => import('../pages/dashboard/LegacyImpactPage')));

// DEMO COMPONENTS
// ----------------------------------------------------------------------

export const ComponentsOverviewPage = Loadable(
  lazy(() => import('../pages/components/ComponentsOverviewPage'))
);

// FOUNDATION
export const FoundationColorsPage = Loadable(
  lazy(() => import('../pages/components/foundation/FoundationColorsPage'))
);
export const FoundationTypographyPage = Loadable(
  lazy(() => import('../pages/components/foundation/FoundationTypographyPage'))
);
export const FoundationShadowsPage = Loadable(
  lazy(() => import('../pages/components/foundation/FoundationShadowsPage'))
);
export const FoundationGridPage = Loadable(
  lazy(() => import('../pages/components/foundation/FoundationGridPage'))
);
export const FoundationIconsPage = Loadable(
  lazy(() => import('../pages/components/foundation/FoundationIconsPage'))
);

// MUI COMPONENTS
export const MUIAccordionPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIAccordionPage'))
);
export const MUIAlertPage = Loadable(lazy(() => import('../pages/components/mui/MUIAlertPage')));
export const MUIAutocompletePage = Loadable(
  lazy(() => import('../pages/components/mui/MUIAutocompletePage'))
);
export const MUIAvatarPage = Loadable(lazy(() => import('../pages/components/mui/MUIAvatarPage')));
export const MUIBadgePage = Loadable(lazy(() => import('../pages/components/mui/MUIBadgePage')));
export const MUIBreadcrumbsPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIBreadcrumbsPage'))
);
export const MUIButtonsPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIButtonsPage'))
);
export const MUICheckboxPage = Loadable(
  lazy(() => import('../pages/components/mui/MUICheckboxPage'))
);
export const MUIChipPage = Loadable(lazy(() => import('../pages/components/mui/MUIChipPage')));
export const MUIDataGridPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIDataGridPage'))
);
export const MUIDialogPage = Loadable(lazy(() => import('../pages/components/mui/MUIDialogPage')));
export const MUIListPage = Loadable(lazy(() => import('../pages/components/mui/MUIListPage')));
export const MUIMenuPage = Loadable(lazy(() => import('../pages/components/mui/MUIMenuPage')));
export const MUIPaginationPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIPaginationPage'))
);
export const MUIPickersPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIPickersPage'))
);
export const MUIPopoverPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIPopoverPage'))
);
export const MUIProgressPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIProgressPage'))
);
export const MUIRadioButtonsPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIRadioButtonsPage'))
);
export const MUIRatingPage = Loadable(lazy(() => import('../pages/components/mui/MUIRatingPage')));
export const MUISliderPage = Loadable(lazy(() => import('../pages/components/mui/MUISliderPage')));
export const MUIStepperPage = Loadable(
  lazy(() => import('../pages/components/mui/MUIStepperPage'))
);
export const MUISwitchPage = Loadable(lazy(() => import('../pages/components/mui/MUISwitchPage')));
export const MUITablePage = Loadable(lazy(() => import('../pages/components/mui/MUITablePage')));
export const MUITabsPage = Loadable(lazy(() => import('../pages/components/mui/MUITabsPage')));
export const MUITextFieldPage = Loadable(
  lazy(() => import('../pages/components/mui/MUITextFieldPage'))
);
export const MUITimelinePage = Loadable(
  lazy(() => import('../pages/components/mui/MUITimelinePage'))
);
export const MUITooltipPage = Loadable(
  lazy(() => import('../pages/components/mui/MUITooltipPage'))
);
export const MUITransferListPage = Loadable(
  lazy(() => import('../pages/components/mui/MUITransferListPage'))
);
export const MUITreesViewPage = Loadable(
  lazy(() => import('../pages/components/mui/MUITreesViewPage'))
);

// EXTRA
export const DemoAnimatePage = Loadable(
  lazy(() => import('../pages/components/extra/DemoAnimatePage'))
);
export const DemoCarouselsPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoCarouselsPage'))
);
export const DemoChartsPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoChartsPage'))
);
export const DemoCopyToClipboardPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoCopyToClipboardPage'))
);
export const DemoEditorPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoEditorPage'))
);
export const DemoFormValidationPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoFormValidationPage'))
);
export const DemoImagePage = Loadable(
  lazy(() => import('../pages/components/extra/DemoImagePage'))
);
export const DemoLabelPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoLabelPage'))
);
export const DemoLightboxPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoLightboxPage'))
);
export const DemoMapPage = Loadable(lazy(() => import('../pages/components/extra/DemoMapPage')));
export const DemoMegaMenuPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoMegaMenuPage'))
);
export const DemoMultiLanguagePage = Loadable(
  lazy(() => import('../pages/components/extra/DemoMultiLanguagePage'))
);
export const DemoNavigationBarPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoNavigationBarPage'))
);
export const DemoOrganizationalChartPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoOrganizationalChartPage'))
);
export const DemoScrollbarPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoScrollbarPage'))
);
export const DemoSnackbarPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoSnackbarPage'))
);
export const DemoTextMaxLinePage = Loadable(
  lazy(() => import('../pages/components/extra/DemoTextMaxLinePage'))
);
export const DemoUploadPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoUploadPage'))
);
export const DemoMarkdownPage = Loadable(
  lazy(() => import('../pages/components/extra/DemoMarkdownPage'))
);

export const LegacyTrainingPage = Loadable(
  lazy(() => import('../pages/dashboard/legacy-training/LegacyTrainingPage'))
);

export const LegacyAwardPage = Loadable(
  lazy(() => import('../pages/dashboard/legacy-award/LegacyAwardPage'))
);

export const EconomicImpactIndexPage = Loadable(
  lazy(() => import('../pages/dashboard/economic-imapct-index/EconomicImpactIndexPage'))
);
